<template>
  <div>
    <div class="topNav">
      <el-dropdown @command="switchCurrency" class="currency-switch" trigger="click"
                   @visible-change="tooltipShow=false">

        <el-tooltip :content="$t('Display currencies are for reference only')" placement="left" effect="light"
                    v-model="tooltipShow">
          <span class="el-dropdown-link">
            <i class="el-icon-date"></i>{{ $t(currentCurrency) }}<i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
        </el-tooltip>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            :command="currency"
            v-for="currency of currencies"
            :class="{active:currentCurrency===currency}"
            :key="currency">
            {{ $t(currency) }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown @command="switchLang" class="lang-switch" trigger="click">
      <span class="el-dropdown-link">
        <i class="el-icon-date"></i>{{ langs[currentLang] }}<i class="el-icon-caret-bottom el-icon--right"></i>
      </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(v,k) of langs"
            :command="k"
            :key="k"
            :class="{active:currentLang===k}"
            :disabled="currentLang===k">
            {{ v }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown v-if="username && isShowUserCenter" class="user-switch" trigger="click">
        <span class="el-dropdown-link">
          <i class="el-icon-user"></i>{{username}}<i class="el-icon-caret-bottom el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item class="user-link">
            <el-button
              @click="toUserCenter">
              {{$t('User Center')}}
            </el-button>
          </el-dropdown-item>
          <el-dropdown-item class="logout">
            <el-button
              @click="logOut">
              {{$t('Sign Out')}}
            </el-button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="mob-switcher" @click="showSwitch=true">
        <span>{{ langs[currentLang] }}</span><span class="mob-currency-switch">/{{ $t(currentCurrency) }}</span> <i
        class="el-icon-caret-bottom"></i>
      </div>
      <div class="mob-switcher" v-if="username && isShowUserCenter" @click="showUserSwitch=true">
        <i class="el-icon-user"></i>
      </div>
    </div>
    <div class="user-info" v-if="username && isShowUserCenter">
      {{ $t('Available Rate') }}{{ $t('Employee Rate') }}{{employeeQuota}} {{$t('nights')}} | {{ $t('Friends & Family Rate') }}{{fnfQuota}} {{$t('nights')}}
    </div>
    <silk-popup :show="showSwitch" @popup-close="showSwitch=false" class="switch-popup">

      <div class="mob-switch">
        <p>{{ $t('Please choose your language') }}:</p>

        <div class="lang-content">
          <el-button
            v-for="(v,k) of langs"
            :key="k"
            @click="switchLang(k)"
            :class="{active:currentLang===k}">
            {{ v }}
          </el-button>
        </div>

        <p>{{ $t('Please choose your currency') }}:</p>

        <div class="currency-content">
          <el-dropdown @command="switchCurrency" class="currency-switch" trigger="click">
            <span class="el-dropdown-link">
              {{ $t(currentCurrency) }}<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="currency-selecter">
              <el-dropdown-item
                :command="currency"
                v-for="currency of currencies"
                :class="{active:currentCurrency===currency}"
                :key="currency">
                {{ $t(currency) }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </div>

        <p class="tips"><i class="el-icon-warning-outline"/>{{ $t('Display currencies are for reference only') }}</p>


      </div>

    </silk-popup>
    <silk-popup :show="showUserSwitch" @popup-close="showUserSwitch=false" class="switch-popup">
      <div class="mob-switch">
        <div class="userCenter-content">
          <div class="mobile-name" v-if="username && isShowUserCenter">
            {{username}}
          </div>
          <el-button @click="toUserCenter" class="active">
            {{$t('User Center')}}
          </el-button>
          <el-button @click="logOut">
            {{$t('Sign Out')}}
          </el-button>
        </div>
      </div>
    </silk-popup>
  </div>

</template>

<script>
import {mapState} from 'vuex'
export default {
  data() {
    return {
      langs: {
        en: 'EN',
        cn: '简',
        tc: '繁',
        // jap: '日本語',
        // ko: '한국어'
      },
      currencies: ['MOP', 'HKD', 'CNY', 'USD', 'JPY', 'KRW'],
      showSwitch: false,
      mobLang: '',
      mobCurrency: '',
      tooltipShow: false,
      showUserSwitch: false,
    }
  },
  methods: {
    switchLang(lang) {
      if (lang === this.currentLang) {
        return
      }
      this.$router.replace({name: this.$route.name, query: Object.assign({}, this.$route.query, {lang})})
      document.querySelector('html').setAttribute('lang', this.htmlLang)
      this.showSwitch = false
    },
    switchCurrency(currency) {
      this.$store.commit('stateChange', {k: 'currency', v: currency})
      localStorage.setItem("currency", currency);
      this.$router.replace({
        path: '/refresh',
        query: {
            'skin': this.skin
        }
      })
      this.showSwitch = false
    },
    toUserCenter() {
      this.showUserSwitch = false
      this.$router.push({name: 'UserCenter'})
    },
    logOut() {
      this.fullLoading = true
      this.showUserSwitch = false
      this.axios.post('/api/employee/auth/logout')
      .then((res) => {
        if (res.code === 200 || res.code === 401) {
          localStorage.removeItem('Authorization')
          localStorage.removeItem('isForceChange')
          localStorage.removeItem('username')
          localStorage.removeItem('employee_quota')
          localStorage.removeItem('employee_rate')
          localStorage.removeItem('fnf_quota')
          localStorage.removeItem('fnf_rate')
          this.$router.push({name: 'Login'})
        } else {
          this.$alert(res.msg, {
              confirmButtonText: this.$t('CLOSE'),
              center: true,
          })
        }
        }).finally(() => {
        this.fullLoading = false
      })
    }
  },
  computed: {
    ...mapState(
      ['gaData']
    ),
    currentLang() {
      return this.$i18n.locale
    },
    htmlLang() {
      const langs = {
        en: 'en-US',
        cn: 'zh-CN',
        tc: 'zh-TW',
        jap: 'ja',
        ko: 'kr'
      }
      return langs[this.currentLang]
    },
    currentCurrency() {
      return this.$store.state.currency || localStorage.currency || this.currencies[0]
    },
    username() {
      return this.$store.state.username || localStorage.username
    },
    employeeQuota() {
      return this.$store.state.employeeQuota >= 0 ? this.$store.state.employeeQuota : localStorage.employee_quota
    },
    fnfQuota() {
      return this.$store.state.fnfQuota >= 0 ? this.$store.state.fnfQuota : localStorage.fnf_quota
    },
    isShowUserCenter() {
      if(this.$route.name !== 'ResetPassword' && this.$route.name !== 'ChangePassword' && this.$route.name !== 'Login') return true
      else return false
    },
    timeout() {
      return this.$store.state.timeout
    },
    serverTime() {
      return this.$store.state.serverTime
    },
  },
  created() {
    this.mobLang = this.currentLang
    this.mobCurrency = this.currentCurrency
    document.querySelector('html').setAttribute('lang', this.htmlLang)
  },
  watch: {
    serverTime(time) {
      clearTimeout(window.timer)
      if(time !== null && localStorage.Authorization) {
        window.timer = setTimeout(() => {
          this.logOut()
        }, this.timeout)
      }
    }
  }
}
</script>
